
// V1
import React, { useContext } from "react";

import Header from "../components/header"
import Footer from "../components/footer"
import Body from "../components/body"
import { LanguageContext } from "../context/LanguageContext"
import Side1 from "../components/side1";
import Chart1 from '../components/chart1';
import Chart2 from "../components/chart2";
import Chart3 from "../components/chart3";
import Chart4 from "../components/chart4";
import Chart5 from "../components/chart5";
import Chart6 from "../components/chart6";
import Chart7 from "../components/chart7";
import HomeDashBoard from "../components/homeDashBoard";

import CompanyInfo from "../components/companyInfo";
import UsersCount from "../components/usersCount";
import UsersName from "../components/usersInfo";

import MachinesList from "../components/machineList";
import MachinesList2 from "../components/machineList2";
import CompanyName from "../components/companyname";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";


const Home = () => {

  const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));

  const id_c = JSON.parse(localStorage.getItem("company"))?.id_c;
  const id_u = JSON.parse(localStorage.getItem("user"))?.id_u;

  const navigate = useNavigate();

  return (
    <>


      <div class="body">
        <Header />
        
        <div>

          <HomeDashBoard/>
          
          {/*}
          <table className="table3">

*/}

            <td>
{/*}
              <tr>
                <img className="logo3" src={company.logo_c} alt="Company Logo"></img>
              </tr>
   */}
              {/*<tr>
                <CompanyInfo id_c={company.id_c} />
              </tr>
              */}
             {/*} <tr>
                <UsersCount id_c={company.id_c} />
              </tr>
              */}
            </td>
{/*
          </table>
   */}
        </div>
        
 
        {/*<UsersCount id_c={company.id_c} />


          <UsersName id_c={id_c} id_u={id_u} /> 
          */}

        <hr />



      </div>





    </>
  )
}

export default Home;